import { JOUR_AUTOUR, type Rectangle } from './zoneALEcran';
import './AnneauTuto.css';

/**
 * L'anneau autour de ce qu'il faut toucher (tickets 33 et 45), posé autour de la zone et
 * gardé dans la fenêtre. Partagé par la visite et le bandeau ; son dessin est dans
 * `AnneauTuto.css`. Il ne capte aucun clic.
 */

/** L'épaisseur du trait, dessiné vers l'intérieur du rectangle (`border` de AnneauTuto.css). */
const TRAIT_ANNEAU = 4;
/**
 * De la zone au bord extérieur de l'anneau : le trait y tient, avec deux pixels de jour
 * entre lui et la zone, où se pose son liseré blanc intérieur.
 */
const ECART_ANNEAU = TRAIT_ANNEAU + 4;
/** Ce que l'anneau laisse au bord de la fenêtre : son liseré et son halo y restent visibles. */
const BORD_ANNEAU = JOUR_AUTOUR;

/**
 * Le rectangle de l'anneau autour d'une zone, gardé dans la fenêtre : une zone près du bord
 * (la petite poubelle au bout d'une ligne de « Projets ») garde son anneau entier à l'écran.
 * Le rectangle ne descend jamais sous la zone : une zone collée au bord de la fenêtre voit
 * alors son bord couvert par le trait, mais le clic passe toujours (`pointer-events: none`).
 */
export function rectangleDeLAnneau(zone: Rectangle, fenetre: { largeur: number; hauteur: number }): Rectangle {
  const gauche = Math.min(zone.x, Math.max(BORD_ANNEAU, zone.x - ECART_ANNEAU));
  const haut = Math.min(zone.y, Math.max(BORD_ANNEAU, zone.y - ECART_ANNEAU));
  const droite = Math.max(
    zone.x + zone.largeur,
    Math.min(fenetre.largeur - BORD_ANNEAU, zone.x + zone.largeur + ECART_ANNEAU)
  );
  const bas = Math.max(
    zone.y + zone.hauteur,
    Math.min(fenetre.hauteur - BORD_ANNEAU, zone.y + zone.hauteur + ECART_ANNEAU)
  );
  return { x: gauche, y: haut, largeur: droite - gauche, hauteur: bas - haut };
}

export function AnneauTuto({ zone, className }: { zone: Rectangle; className?: string }) {
  const r = rectangleDeLAnneau(zone, { largeur: window.innerWidth, hauteur: window.innerHeight });
  return (
    <div
      className={className ? `anneau-tuto ${className}` : 'anneau-tuto'}
      style={{ left: r.x, top: r.y, width: r.largeur, height: r.hauteur, borderWidth: TRAIT_ANNEAU }}
      aria-hidden="true"
    />
  );
}
